import {
  GET_PROJECT_VARIABLES_SUCCESS,
  CREATE_PROJECT_VARIABLE_SUCCESS,
  CREATE_PROJECT_VARIABLE_FAILURE,
  DELETE_PROJECT_VARIABLE_SUCCESS,
  DELETE_PROJECT_VARIABLE_FAILURE,
  UPDATE_PROJECT_VARIABLE_SUCCESS,
  UPDATE_PROJECT_VARIABLE_FAILURE,
  SEARCH_PROJECT_VARIABLES
} from '../../../actions'
import { Logger, LoggerTypes } from '../../../utils'
let cacheItems = null

export const projectVariables = (state = {}, action) => {
  switch (action.type) {
    case GET_PROJECT_VARIABLES_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectVariables.GET_PROJECT_VARIABLES_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }
    case CREATE_PROJECT_VARIABLE_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectVariables.CREATE_PROJECT_VARIABLE_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }
    case CREATE_PROJECT_VARIABLE_FAILURE: {
      return { ...state, error: action.data }
    }
    case UPDATE_PROJECT_VARIABLE_SUCCESS: {
      const newItems = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectVariables.UPDATE_PROJECT_VARIABLE_SUCCESS()', {
        state,
        action,
        newItems
      })
      return {
        ...state,
        items: newItems
      }
    }
    case UPDATE_PROJECT_VARIABLE_FAILURE: {
      return { ...state, error: action.data }
    }
    case DELETE_PROJECT_VARIABLE_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectVariables.DELETE_PROJECT_VARIABLE_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }
    case DELETE_PROJECT_VARIABLE_FAILURE: {
      return { ...state, error: action.data }
    }
    case SEARCH_PROJECT_VARIABLES: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }

      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      return {
        ...state,
        items: searchItems
      }
    }
    default:
      return state
  }
}
